import { useLazyQuery } from '@apollo/client'
import { GET_SCHOOLS_BY_EMAIL } from './queries/getSchoolsByEmail'

export const useGetSchoolsByEmail = () => {
  const [getSchoolsByEmail, { data, loading, error }] =
    useLazyQuery(GET_SCHOOLS_BY_EMAIL)

  return { getSchoolsByEmail, data, loading, error }
}
